module.exports = __webpack_public_path__ + "s/img/Glam_M_1.6e153d8a.jpg";